import { httpGet } from './api/axios_api';
import Constants from '../constants/constants';

export async function getMetabaseDashboardURL(organizationID) {
  if (typeof organizationID === 'undefined') {
    organizationID = -1;
  }

  let url;
  if (parseInt(organizationID, 10) === -1) {
    url = `${Constants.BACKEND_URL}/get-metabase-dashboard`;
  } else {
    url = `${Constants.BACKEND_URL}/get-metabase-dashboard/organization/` + organizationID;
  }

  return httpGet(url, {});
}

export async function getTherapyRefusalMetabaseDashboard() {
  const url = Constants.BACKEND_URL + '/metabase/therapy-refusal-dashboard';

  return httpGet(url, {});
}

export async function getRegionalRefusalMetabaseDashboard(token) {
  const url = Constants.BACKEND_URL + '/metabase/regional-refusal-dashboard';

  return httpGet(url, {}, token);
}

export async function getSecurityMetabaseDashboard(dashboard_name) {
  const url = `${Constants.BACKEND_URL}/metabase/security/${dashboard_name}`;
  return httpGet(url, {});
}
